import LazyLoad from "vanilla-lazyload";
import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import zenscroll from "zenscroll";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let bh = window.innerHeight;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const main = document.querySelector("main");
const footer = document.querySelector("footer");
const footerInner = footer.querySelector(".inner");
const footerLogo = footer.querySelector(".logo img");
const colorWash = document.getElementById("color_wash");
const menuBtn = document.querySelector(".menuBtn");
const scrollTopEl = document.getElementById("backToTop");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const headerStamp = document.querySelector("header img.stamp");
const header = document.querySelector("header");
const overlay = document.getElementById("overlay");
const overlayProject = document.getElementById("project_overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayProjectInner = overlayProject.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closeIcon");

const colorThemes = [
  { class: "theme_green", logo: "H_A-branding-wordmark-black.png" },
  { class: "theme_purple", logo: "H_A-branding-wordmark-blue.png" },
  { class: "theme_orange", logo: "H_A-branding-wordmark-lavender.png" },
  { class: "theme_brown", logo: "H_A-branding-wordmark-white.png" },
  { class: "theme_tan", logo: "H_A-branding-wordmark-red.png" },
];

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  let os = "Unknown";
  if (navigator.appVersion.indexOf("Win") != -1) os = "Windows";
  if (navigator.appVersion.indexOf("Mac") != -1) os = "MacOS";
  if (navigator.appVersion.indexOf("X11") != -1) os = "UNIX";
  if (navigator.appVersion.indexOf("Linux") != -1) os = "Linux";

  if (os === "MacOS") {
    body.classList.add("mac");
  }

  const uA = navigator.userAgent;
  const vendor = navigator.vendor;
  if (
    /Safari/i.test(uA) &&
    /Apple Computer/.test(vendor) &&
    !/Mobi|Android/i.test(uA)
  ) {
    //Desktop Safari
    body.classList.add("safari");
  }

  // pick random color theme - assign to footer and color wash
  let colorTheme = colorThemes[Math.floor(Math.random() * colorThemes.length)];

  footerLogo.setAttribute("src", "/images/logos/" + colorTheme.logo);
  footer.classList.add(colorTheme.class);
  colorWash.classList.add(colorTheme.class);

  function infoPageStampInit() {
    // textpage stamp parallax
    let stamp1El = document.querySelector(".stamp1");
    if (typeof stamp1El != "undefined" && stamp1El != null) {
      gsap.to(stamp1El, {
        top: "-35vh",
        scrollTrigger: {
          trigger: body,
          start: "top top",
          end: "bottom top",
          markers: false,
          scrub: true,
        },
      });
    }

    let stamp2El = document.querySelector(".stamp2");
    if (typeof stamp2El != "undefined" && stamp2El != null) {
      gsap.to(stamp2El, {
        top: -100,
        scrollTrigger: {
          trigger: body,
          start: "top top",
          end: "bottom top",
          markers: false,
          scrub: true,
        },
      });
    }

    let stamp3El = document.querySelector(".stamp3");
    if (typeof stamp3El != "undefined" && stamp3El != null) {
      gsap.to(stamp3El, {
        marginTop: 100,
        scrollTrigger: {
          trigger: body,
          start: "top top",
          end: "bottom top",
          markers: false,
          scrub: true,
        },
      });
    }
  }

  infoPageStampInit();

  // intro loading sequence - loose grid

  let introEl = document.querySelector(".intro_loose_grid");
  if (typeof introEl != "undefined" && introEl != null) {
    // setup a GSAP timeline to animate the intro
    let introTimeline = gsap.timeline({
      defaults: { y: "-100vh", ease: "power2.out" },
    });
    let introCells = introEl.querySelectorAll(".cell");
    let introLogo = introEl.querySelector(".logo");

    // set initial state of the cells off the screen with translate Y value
    gsap.set(introLogo, { y: "5rem", opacity: 0 });
    gsap.set(introCells, { y: "100vh", opacity: 0 });

    // check for matchMedia
    let mm = gsap.matchMedia();

    mm.add("(min-width: 932px)", () => {
      // animate the cells - DESKTOP
      introTimeline
        .to(introCells, { inherit: false, opacity: 1, duration: 1 }, 0)
        .to(introCells[0], { duration: 5 }, 0)
        .to(introCells[1], { duration: 4.5 }, 0.3)
        .to(introCells[2], { duration: 6 }, 0.6)
        .to(introCells[3], { duration: 4 }, 0.8)
        .to(introCells[4], { duration: 6 }, 1)
        .to(introCells[5], { duration: 6 }, 1.5)
        .to(introCells[6], { duration: 5.5 }, 2)
        .to(introCells[7], { duration: 4.5 }, 2)
        .addLabel("fade")
        .to(introCells, { inherit: false, opacity: 0, duration: 1 }, 2.5)
        .addLabel("logo")
        .to(introLogo, { inherit: false, duration: 1, y: 0, opacity: 1 }, 3.2)
        .to(
          introLogo,
          {
            inherit: false,
            duration: 1,
            opacity: 0,
          },
          5
        );
    });

    mm.add("(max-width: 932px)", () => {
      // animate the cells - MOBILE
      introTimeline
        .to(introCells, { inherit: false, opacity: 1, duration: 1 }, 0)
        .to(introCells[0], { duration: 5 }, 0)
        .to(introCells[1], { duration: 4.5 }, 0.3)
        .to(introCells[2], { duration: 6 }, 0.6)
        .to(introCells[3], { duration: 4 }, 0.8)
        .to(introCells[4], { duration: 6 }, 1)
        .to(introCells[5], { duration: 5 }, 1.5)
        .to(introCells[6], { duration: 5.5 }, 2)
        .to(introCells[7], { duration: 7 }, 2)
        .addLabel("fade")
        .to(introCells, { inherit: false, opacity: 0, duration: 1 }, 2.5)
        .addLabel("logo")
        .to(introLogo, { inherit: false, duration: 1, y: 0, opacity: 1 }, 3.2)
        .to(
          introLogo,
          {
            inherit: false,
            duration: 1,
            opacity: 0,
          },
          5
        );
    });

    setTimeout(function () {
      main.classList.add("loading");

      // ajax call to get homepage content
      getAjax("/content.php?page=/", function (data) {
        main.querySelector("#content").innerHTML = data;
        // call necessary loading functions
        footerInit();
        hScrollInit();
        lazyLoadInit();
        masonInit();

        //gsap.set(document.querySelector(".large_title.home"), {opacity: 1});
        // init any new ajax links
        let newAjaxLinks = main
          .querySelector("#content")
          .querySelectorAll("a.ajax");
        newAjaxLinks.forEach((newAjaxLink) => {
          newAjaxLink.addEventListener("click", function (e) {
            e.preventDefault();
            let page = newAjaxLink.getAttribute("href");
            loadContent(page);
          });
        });
      });
    }, 3000);

    setTimeout(function () {
      body.classList.remove("loading");
      main.classList.add("reveal");
    }, 5500);

    setTimeout(function () {
      main.classList.remove("loading");
    }, 6500);
  }

  /*
  // intro loading sequence - mask reveal (old)
  let introEl = document.querySelector(".intro_mask_reveal");
  if (typeof introEl != "undefined" && introEl != null) {
    let introImages = introEl.querySelectorAll("img.photo");
    let introImagescount = introImages.length;
    let introTimer;
    let introCount = 1;

    function activeImage() {
      introImages[introCount].classList.add("active");
      ++introCount;
      if (introCount >= introImagescount) {
        // clear the photo timer
        clearInterval(introTimer);

        // introduce color wash
        setTimeout(function () {
          colorWash.classList.add("transition_in_fast");
          getAjax("/content.php?page=/", function (data) {
            main.querySelector("#content").innerHTML = data;
            // call necessary loading functions
            hScrollInit();
            lazyLoadInit();
            masonInit();
            //gsap.set(document.querySelector(".large_title.home"), {opacity: 1});
            // init any new ajax links
            let newAjaxLinks = main
              .querySelector("#content")
              .querySelectorAll("a.ajax");
            newAjaxLinks.forEach((newAjaxLink) => {
              newAjaxLink.addEventListener("click", function (e) {
                e.preventDefault();
                let page = newAjaxLink.getAttribute("href");
                loadContent(page);
              });
            });
          });
        }, 800);
        setTimeout(function () {
          body.classList.remove("loading");
        }, 1200);
        setTimeout(function () {
          colorWash.classList.add("transition_out_fast");
          footerInit();
        }, 1500);
        setTimeout(function () {
          colorWash.classList.remove("transition_out_fast");
          colorWash.classList.remove("transition_in_fast");
        }, 3000);
      }
    }

    introTimer = setInterval(activeImage, 500);
  } else {
    if (body.classList.contains("homepage")) {
      getAjax("/content.php?page=/", function (data) {
        main.querySelector("#content").innerHTML = data;
        // call necessary loading functions
        hScrollInit();
        footerInit();
        lazyLoadInit();
        masonInit();
        // init any new ajax links
        let newAjaxLinks = main
          .querySelector("#content")
          .querySelectorAll("a.ajax");
        newAjaxLinks.forEach((newAjaxLink) => {
          newAjaxLink.addEventListener("click", function (e) {
            e.preventDefault();
            let page = newAjaxLink.getAttribute("href");
            loadContent(page);
          });
        });
      });
    }
  }

*/

  // check for projectpage in body tag, if found this is a direct link to a project overlay
  let projectPageCheck = false;
  if (body.classList.contains("projectpage")) {
    projectPageCheck = true;
    let projectId = body.getAttribute("data-projectid");
    let targetCell = document.querySelector(
      ".cell[data-id='" + projectId + "']"
    );
    setTimeout(function () {
      targetCell.click();
    }, 200);
  }

  // info page mobile check to place video under headline
  let infoPageEl = document.querySelector(".info_page");
  if (typeof infoPageEl != "undefined" && infoPageEl != null) {
    if (innerWidth <= 896) {
      let secondaryCol = infoPageEl.querySelector(".secondary .column.first");
      let infoHeadlineEl = infoPageEl.querySelector(".primary h1.large_title");
      infoHeadlineEl.after(secondaryCol);
    }
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function lazyLoadInit() {
    // load any priority images on page load
    let imgPriorityEls = document.querySelectorAll("img.loadmepriority");
    imgPriorityEls.forEach((imgPriorityEl) => {
      loadImage(imgPriorityEl);
    });

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });
    // lazyload grid slideshows
    const lazyLoadSlideshow = new LazyLoad({
      elements_selector: ".grid_slideshow",
      callback_enter: loadSlideshow,
    });
    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
    // global animation effects
    ScrollTrigger.batch(".fadeUp", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }

  lazyLoadInit();

  // check for size load videos on page load
  let sizeLoadVideoEls = document.querySelectorAll("video.sizeload");
  sizeLoadVideoEls.forEach((sizeLoadVideoEl) => {
    sizeloadVideo(sizeLoadVideoEl);
  });

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playFullVideo(el) {
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.load();
      videoEl.oncanplay = function () {
        videoEl.play();
        videoEl.classList.add("ready");
      };
    } else {
      let videoStr = el.getAttribute("data-video");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.load();
      videoEl.oncanplay = function () {
        videoEl.play();
        videoEl.classList.add("ready");
      };
    }
    el.classList.add("playing");
  }

  function playAutoVideo(el) {
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  // initialize masonry

  function resizeBioCell() {
    // double wide
    let bioCells = document.querySelectorAll(".cell.homebio.double");
    let bioCellsLength = bioCells.length;
    for (let i = 0; i < bioCellsLength; ++i) {
      let bioImg = bioCells[i].querySelector(".mediawrap");
      let imgH = bioImg.clientHeight;
      let bioText = bioCells[i].querySelector(".textwrap");
      let bioTextWrap = bioText.querySelector(".thetext");
      let bioTextH = bioCells[i].clientHeight;

      bioTextWrap.style.height = imgH - 39 + "px";
    }

    // single col
    let bioCellsSingle = document.querySelectorAll(".cell.homebio.single");
    let bioCellsSingleLength = bioCellsSingle.length;
    for (let i = 0; i < bioCellsSingleLength; ++i) {
      let bioText = bioCellsSingle[i].querySelector(".textwrap");
      let bioTextWrap = bioText.querySelector(".thetext");

      bioTextWrap.style.height = bw * 0.15 + "px";
    }
  }

  let msnry;

  function masonInit() {
    let masongrids = document.querySelectorAll(".masongrid");
    let masongridsLength = masongrids.length;
    for (let g = 0; g < masongridsLength; ++g) {
      let masongrid = masongrids[g];
      if (
        body.classList.contains("artistpage") ||
        body.classList.contains("postpage")
      ) {
        //injecting bottom margin into masonry cell
        let gutterWidth = masongrid.querySelector(".gutter-sizer").scrollWidth;
        let cells = masongrid.getElementsByClassName("cell");
        for (var i = 0; i < cells.length; i++) {
          cells[i].style.marginBottom = gutterWidth + "px";
        }
      }

      msnry = new Masonry(masongrid, {
        itemSelector: ".cell",
        columnWidth: ".grid-sizer",
        gutter: ".gutter-sizer",
      });
      resizeBioCell();

      msnry.on("layoutComplete", function (items) {
        masongrid.style.opacity = 1;
        let masonImgs = document.querySelectorAll(".loadmemason");
        masonImgs.forEach((masonImg) => {
          masonImg.classList.add("loadmeview");
          lazyLoadInit();
        });
      });

      msnry.layout();
    }
  }

  masonInit();

  // inline grid slideshows triggered by hover events

  function loadSlideshow(el) {
    let theSlideshow = el.querySelector(".inline_slideshow");
    let currentCount = el.querySelector(".imgcount .current");

    // simple single fade between 2 images
    if (typeof theSlideshow != "undefined" && theSlideshow != null) {
      theSlideshow.addEventListener("mouseenter", function () {
        let slides = theSlideshow.querySelectorAll(".slide");
        slides[1].classList.add("active");
        currentCount.innerHTML = "2";
      });
      theSlideshow.addEventListener("mouseleave", function () {
        let slides = theSlideshow.querySelectorAll(".slide");
        slides[1].classList.remove("active");
        currentCount.innerHTML = "1";
      });
    }
  }

  // nav slideshow
  let navSlideshow = document.querySelector(".nav_slideshow");
  if (typeof navSlideshow != "undefined" && navSlideshow != null) {
    let flkty_nav = new Flickity(navSlideshow, {
      // options
      fade: true,
      autoPlay: 3500,
      pauseAutoPlayOnHover: false,
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      draggable: false,
    });
  }

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let halfScreen = bw / 2;

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    const arrowNext = document.querySelector(".ui.next");
    const arrowPrev = document.querySelector(".ui.prev");
    const closeEl = slideshowEl.querySelector(".closeLink");

    arrowNext.addEventListener("click", nextSlide);
    arrowPrev.addEventListener("click", prevSlide);

    // left / rightside mouseenter for arrow navigation
    slideshowEl.addEventListener("mousemove", function (e) {
      location.x = e.pageX;
      location.y = e.pageY;

      if (location.x < halfScreen) {
        body.classList.add("leftside");
        body.classList.remove("rightside");
      } else {
        body.classList.add("rightside");
        body.classList.remove("leftside");
      }
    });

    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      draggable: true,
      on: {
        ready: function () {
          if (!window.location.hash || window.location.hash == "#1") {
            let activeSlide = slideshowEl.querySelector(".is-selected");
            let activeId = activeSlide.getAttribute("data-picid");
            slideshowEl
              .querySelector(".lightbox_trigger")
              .setAttribute("data-id", activeId);

            // check if slide image is in lightbox, if yes we need to update lb trigger
            let inLightbox = false;
            if (activeSlide.classList.contains("added")) {
              inLightbox = true;
            }
            if (inLightbox) {
              slideshowEl
                .querySelector(".lightbox_trigger")
                .classList.add("added");
            }
            let activeImg = activeSlide.querySelector("img");
            if (activeSlide.classList.contains("slideautovideo")) {
              playAutoVideo(activeSlide);
            } else if (activeSlide.classList.contains("video")) {
              playFullVideo(activeSlide);
            } else {
              loadImage(activeImg);
            }
          }
        },
      },
    });

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;

      // update the close link with slideCount
      let currentCloseLink = closeEl.getAttribute("data-link");
      let newCloseLink = currentCloseLink + "#" + slideCount;
      closeEl.setAttribute("href", newCloseLink);

      // pause any playing videos
      let slideVideos = slideshowEl.querySelectorAll("video");
      let slideVideosLength = slideVideos.length;
      for (let i = 0; i < slideVideosLength; ++i) {
        slideVideos[i].pause();
      }

      let activeSlide = slideshowEl.querySelector(".is-selected");
      let activeId = activeSlide.getAttribute("data-picid");
      slideshowEl
        .querySelector(".lightbox_trigger")
        .setAttribute("data-id", activeId);
      // check if slide image is in lightbox, if yes we need to update lb trigger
      let inLightbox = false;
      if (activeSlide.classList.contains("added")) {
        inLightbox = true;
      }
      if (inLightbox) {
        slideshowEl.querySelector(".lightbox_trigger").classList.add("added");
      } else {
        slideshowEl
          .querySelector(".lightbox_trigger")
          .classList.remove("added");
      }

      let activeImg = activeSlide.querySelector("img");
      if (activeSlide.classList.contains("slideautovideo")) {
        playAutoVideo(activeSlide);
      } else if (activeSlide.classList.contains("video")) {
        playFullVideo(activeSlide);
      } else {
        loadImage(activeImg);
      }

      // update hash value
      window.location.hash = slideCount;
    });

    // check for hash value on page load, advanced to that slide
    if (window.location.hash) {
      let slideHash = window.location.hash;
      let cleanHash = slideHash.replace("#", "");
      goToSlide(cleanHash);
    }

    function goToSlide(index) {
      // get index of slide based on data-id attr
      let slideIndex = slideshowEl.querySelector(
        ".cell[data-id='" + index + "']"
      );
      let theIndex = getNodeindex(slideIndex);
      flkty.select(theIndex);
    }

    function nextSlide() {
      flkty.next();
    }

    function prevSlide() {
      flkty.previous();
    }
  }

  /* VIDEO PLAYER PAGE LOAD REQUIRES CHECK FOR TYPE OF VIDEO / IMAGES */
  if (body.classList.contains("videoplayer")) {
    let activeCell = document.querySelector(".cell.active");
    let activeImg = activeCell.querySelector("img");
    if (activeCell.classList.contains("slideautovideo")) {
      playAutoVideo(activeCell);
    } else if (activeCell.classList.contains("video")) {
      playFullVideo(activeCell);
    } else {
      loadImage(activeImg);
    }
  }

  /* custom 360 rotation of top right placed images */
  /*
  let infoImg = document.querySelector(".textpage img.top_right");
  if (typeof infoImg != "undefined" && infoImg != null) {
    // animate all stamps on page
    let stamps = document.querySelectorAll(".textpage .stamps img");
    for (let i = 0; i < stamps.length; ++i) {
      stamps[i].classList.add("active");
    }

    gsap.to(infoImg, 6, {
      rotation: "360",
      ease: "none",
      repeat: -1,
    });
  }
  */

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function getNodeindex(elm) {
    var c = elm.parentNode.children,
      i = 0;
    for (; i < c.length; i++) if (c[i] == elm) return i;
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    // updating image src for beta/local development
    let src = "https://hollandartists.com";
    //let src = "";

    if (image.classList.contains("slideshowimg")) {
      newW = bw;
    }

    if (image.classList.contains("double")) {
      newW = bw / 2;
    }

    // for BETA site update imgpath to full URL
    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = src + "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = src + "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = src + "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = src + "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = src + "/images/pics/1920/" + img;
      } else {
        imgpath = src + "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = src + "/images/pics/500/" + img;
      fullpath = src + "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let colCheck = el.querySelector(".col");
    if (typeof colCheck != "undefined" && colCheck != null) {
      let elContainer = document.createElement("div");
      Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
        elContainer.appendChild(c);
      });
      elContainer.classList.add("cols");
      el.appendChild(elContainer);
    }
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function keyboardClicks(e) {
    if (e.code === "Escape") {
      // Close the modal
      if (body.classList.contains("overlay_open")) {
        e.preventDefault();
        closeOverlay();
      }
    }
    if (e.code === "ArrowDown") {
      // Close the modal
      if (body.classList.contains("overlay_open")) {
        e.preventDefault();
        closeOverlay();
      }
    }
    if (e.code === "ArrowLeft") {
      // prev arrow click
      prevArrow();
    }
    if (e.code === "ArrowRight") {
      // next arrow click
      nextArrow();
    }
  }

  function nextArrow() {
    let activeCell = document.querySelector(".cell.active");
    let activeCount = parseInt(activeCell.getAttribute("data-count"));
    let nextCount = activeCount + 1;
    let nextCell = document.querySelector(
      ".cell[data-count='" + nextCount + "']"
    );
    let targetCell = nextCell;
    if (typeof nextCell == "undefined" || nextCell == null) {
      let targetCells = document.querySelectorAll(".grid .cell.item");
      targetCell = targetCells[0];
    }
    targetCell.click();
  }

  function prevArrow() {
    let activeCell = document.querySelector(".cell.active");
    let activeCount = parseInt(activeCell.getAttribute("data-count"));
    let nextCount = activeCount - 1;
    let nextCell = document.querySelector(
      ".cell[data-count='" + nextCount + "']"
    );
    let targetCell = nextCell;
    if (typeof nextCell == "undefined" || nextCell == null) {
      let targetCells = document.querySelectorAll(".grid .cell.item");
      let cellCount = targetCells.length;
      targetCell = targetCells[cellCount - 1];
    }
    targetCell.click();
  }

  function openProject() {
    overlayProject.classList.add("on");
    body.classList.add("overlay_open");
  }

  function openOverlay(type) {
    if (type === "project") {
      overlay.classList.add("project");
    }

    overlay.classList.add("on");
    body.classList.add("overlay_open");

    if (type !== "project") {
      document.addEventListener("keydown", keyboardClicks, true);

      let touchstartX = 0;
      let touchstartY = 0;
      let touchendX = 0;
      let touchendY = 0;

      const gestureZone = overlayInner;

      gestureZone.addEventListener(
        "touchstart",
        function (event) {
          touchstartX = event.changedTouches[0].screenX;
          touchstartY = event.changedTouches[0].screenY;
        },
        false
      );

      gestureZone.addEventListener(
        "touchend",
        function (event) {
          touchendX = event.changedTouches[0].screenX;
          touchendY = event.changedTouches[0].screenY;
          handleGesture();
        },
        false
      );

      function handleGesture() {
        if (touchendX < touchstartX) {
          nextArrow();
        }

        if (touchendX > touchstartX) {
          prevArrow();
        }

        if (touchendY === touchstartY) {
          nextArrow();
        }
      }

      //let nextArrowEl = overlayInner.querySelector(".wrap img");
      //nextArrowEl.addEventListener("click", nextArrow, true);
      //prevArrowEl.addEventListener("click", prevArrow, true);
    }
  }

  function closeOverlay() {
    let overlayType = "slideshow";
    if (body.classList.contains("project_open")) {
      overlayType = "project";
    }
    overlay.classList.remove("on", "project_open");
    overlay.classList.remove("project");
    overlayProject.classList.remove("on");
    if (overlayType === "project") {
      setTimeout(function () {
        body.classList.remove("overlay_open", "project_open");
      }, 500);
    } else {
      body.classList.remove("overlay_open", "project_open");
    }

    overlayInner.innerHTML = "";

    // get the parent page slug and update URL
    let parentSlug = body.getAttribute("data-slug");
    history.pushState("", "", parentSlug);
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  let resizeId;
  function reportWindowSize() {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 500);

    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  function doneResizing() {
    if (typeof masongrid != "undefined" && masongrid != null) {
      // resize bio cells
      resizeBioCell();
      setTimeout(function () {
        msnry.layout();
      }, 100);
    }
  }

  function getCategory(e) {
    e.preventDefault();
    let category = this;
    let categoryURL = category.getAttribute("href");
    let categorySlug = category.getAttribute("data-slug");
    history.pushState("", "New URL: " + categoryURL, categoryURL);

    // remove pageOn state from all links
    for (let i = 0; i < categoryLinksLength; ++i) {
      categoryLinks[i].classList.remove("pageOn");
    }

    // assign pageOn class to selected
    category.classList.add("pageOn");

    // ajax request to get category content
    let resultsEl = document.querySelector(".results.page");
    if (body.classList.contains("overlay")) {
      resultsEl = overlay.querySelector(".results");
    }
    getAjax("/getCategory.php?slug=" + categorySlug, function (data) {
      // load data into overlay
      resultsEl.innerHTML = data;

      body.classList.add("category_results");

      masonInit();
      lazyLoadInit();
    });
  }

  function removeActiveCell() {
    let activeCells = document.querySelectorAll(".cell.active");
    activeCells.forEach((activeCell) => {
      activeCell.classList.remove("active");
    });
  }

  function closeFilter() {
    let artistFilterEl = document.getElementById("filter");
    if (typeof artistFilterEl != "undefined" && artistFilterEl != null) {
      artistFilterEl.classList.remove("open");
      body.classList.remove("filter_open");
    }
  }

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // newsletter arrow click
  let newsletterArrows = document.querySelectorAll(".submit_form");
  newsletterArrows.forEach((newsletterArrow) => {
    newsletterArrow.addEventListener("click", function (e) {
      e.preventDefault();
      let form = newsletterArrow.closest("form");
      form.submit();
    });
  });

  let footerTl;

  function footerInit() {
    /*
    // need to check for bottomBar and move out of article
    let bottomBar = document.getElementById("bottom_bar");
    if (typeof bottomBar != "undefined" && bottomBar != null) {
      let body = document.querySelector("body");
      body.appendChild(bottomBar);
    }
    */

    // set the footer opacity to 0 to avoid mac bounce at top of browser
    gsap.set(footer, { opacity: 0 });

    // scroll trigger for footer to add animation
    gsap.to(footer, {
      scrollTrigger: {
        trigger: body,
        start: "300",
        end: "+=100",
        markers: false,
        scrub: true,
      },
      opacity: 1,
    });

    gsap.to(main, {
      scrollTrigger: {
        target: main,
        start: "bottom center",
        end: "bottom top",
        scrub: 1,
        markers: false,
      },
      borderBottomLeftRadius: "50px",
      borderBottomRightRadius: "50px",
    });

    gsap.to(footerInner, {
      scrollTrigger: {
        target: main,
        start: "bottom center",
        end: "bottom top",
        scrub: 1,
        markers: false,
      },
      opacity: "1",
    });

    // calculate height of scrollable content
    let contentWrap = document.querySelector("main article");

    if (!body.classList.contains("no_footer")) {
      footerTl = gsap.timeline({
        scrollTrigger: {
          target: "body",
          start: contentWrap.clientHeight - innerHeight,
          end: 100,
          scrub: true,
          markers: false,
        },
      });

      footerTl.to(document.getElementById("bottom_bar"), { autoAlpha: 0 });
      footerTl.scrollTrigger.refresh();
    }

    /*

    gsap.to(document.querySelector(".large_title.home"), {
      scrollTrigger: {
        target: main,
        start: "bottom bottom",
        end: 100,
        scrub: true,
        markers: false,
      },
      opacity: "0",
    });

    */

    ScrollTrigger.refresh();
  }

  // only call footerInit on page load if not the homepage
  if (typeof introEl === "undefined" || introEl == null) {
    footerInit();
  }

  // click event delagation from the body - easier to manage with ajax loading content
  body.addEventListener("click", function (e) {
    let target = e.target;

    // overlay close links
    if (
      target.classList.contains("closeoverlay") ||
      target.classList.contains("closeIcon")
    ) {
      closeOverlay();
      removeActiveCell();
    }

    // overlay project links
    if (target.classList.contains("openProject")) {
      e.preventDefault();
      let id = target.getAttribute("data-id");
      let slug = target.getAttribute("data-slug");
      removeActiveCell();
      target.classList.add("active");
      getAjax("/getProject.php?id=" + id, function (data) {
        overlayProjectInner.innerHTML = data;
        overlayProject.scroll(0, 0);
        body.classList.add("project_open");

        let overlayTopEl = document.querySelector("#overlayToTop");
        let overlayScroller = zenscroll.createScroller(overlay, 500, 0);

        overlayTopEl.addEventListener("click", function () {
          overlayScroller.toY(0);
        });

        // mobile close element needs event listenter to close overlay
        let mobileClose = overlayProject.querySelector(".mobile_close");
        if (typeof mobileClose != "undefined" && mobileClose != null) {
          mobileClose.addEventListener("click", function () {
            closeOverlay();
          });
        }

        // scroll to top of project on arrow click

        let projectTopEl = document.getElementById("projectToTop");
        if (typeof projectTopEl != "undefined" && projectTopEl != null) {
          // if the user scrolls more than 150 pixels within the project_overlay div, show the projectToTop button
          let projectScroller = document.querySelector(
            "#project_overlay .columns"
          );
          projectScroller.addEventListener("scroll", function () {
            if (projectScroller.scrollTop > 200) {
              projectTopEl.classList.add("show");
            } else {
              projectTopEl.classList.remove("show");
            }
          });

          // click event to scroll to top of project
          projectTopEl.addEventListener("click", function () {
            var defaultDuration = 500;
            var edgeOffset = 30;
            var myScroller = zenscroll.createScroller(
              projectScroller,
              defaultDuration,
              edgeOffset
            );
            myScroller.toY(0);
          });
        }

        // get color attribute to update overlay background color
        let bgColor = overlayProjectInner
          .querySelector(".project_content")
          .getAttribute("data-bgcolor");
        let fgColor;
        if (bgColor === "#ffffff") {
          fgColor = "#000000";
        }
        if (bgColor === "#f8f4eb") {
          fgColor = "#AE4341";
        }
        if (bgColor === "#0AAD46") {
          fgColor = "#3C3932";
        }
        if (bgColor === "#3C3932") {
          fgColor = "#F8F4EB";
        }
        if (bgColor === "#F0622C") {
          fgColor = "#D3B7E5";
        }
        if (bgColor === "#D3B7E5") {
          fgColor = "#5A6FA5";
        }
        overlayProject.style.backgroundColor = bgColor;
        overlayProject.style.color = fgColor;
        lazyLoadInit();
        //hScrollInit();

        // setup any sizeload videos
        let sizeLoadVideoEls =
          overlayProject.querySelectorAll("video.sizeload");
        sizeLoadVideoEls.forEach((sizeLoadVideoEl) => {
          sizeloadVideo(sizeLoadVideoEl, "yes");
        });

        openProject();
        // update the URL
        //history.pushState("", "", "/project/" + slug);
      });
    }

    // inline slideshow links - should propagate up to the cell level and open overlay
    if (target.classList.contains("inline_slideshow")) {
      e.preventDefault();
      let parentCell = target.closest(".cell");
      parentCell.click();
    }

    // overlay single item links
    if (target.classList.contains("openOverlay")) {
      e.preventDefault();
      let id = target.getAttribute("data-id");
      let catid = target.getAttribute("data-catid");
      let tag = target.getAttribute("data-tag");
      removeActiveCell();
      target.classList.add("active");
      getAjax(
        "/getItem.php?id=" + id + "&catid=" + catid + "&tag=" + tag,
        function (data) {
          overlayInner.innerHTML = data;
          let photoEl = overlayInner.querySelector("img.photo");
          let sizeLoadVideoEl = overlayInner.querySelector("video.sizeload");
          if (typeof photoEl != "undefined" && photoEl != null) {
            loadImage(photoEl);
          }
          if (
            typeof sizeLoadVideoEl != "undefined" &&
            sizeLoadVideoEl != null
          ) {
            sizeloadVideo(sizeLoadVideoEl);
          }

          // setup next/previous arrow click events
          let nextArrowEl = overlay.querySelector(".arrow.next");
          let prevArrowEl = overlay.querySelector(".arrow.previous");
          nextArrowEl.addEventListener("click", nextArrow, true);
          prevArrowEl.addEventListener("click", prevArrow, true);

          openOverlay();
        }
      );
    }

    // img size toggle between loose and 6 column thumbnail grid

    if (target.id === "img_size") {
      let imgSizeWrap = document.querySelector(".switch");
      let gridPage = imgSizeWrap.getAttribute("data-slug");
      imgSizeWrap.classList.toggle("thumbs");
      if (imgSizeWrap.classList.contains("thumbs")) {
        // to maintain grid view between filters we need to update all portfolio links by prepending /thumbs
        let portfolioLinks = document.querySelectorAll(".portfolio_link");
        portfolioLinks.forEach((portfolioLink) => {
          let currentLink = portfolioLink.getAttribute("data-url");
          if (currentLink != "/") {
            let newLink = "/thumbs" + currentLink;
            portfolioLink.setAttribute("href", newLink);
          }
        });
        loadGrid("/thumbs" + gridPage);
      } else {
        if (gridPage === "/home" || gridPage === "/home-2024") {
          gridPage = "/";
        }
        // to maintain grid view between filters we need to update all portfolio links removing /thumbs/
        let portfolioLinks = document.querySelectorAll(".portfolio_link");
        portfolioLinks.forEach((portfolioLink) => {
          let currentLink = portfolioLink.getAttribute("data-url");
          if (currentLink != "/") {
            portfolioLink.setAttribute("href", currentLink);
          }
        });
        loadGrid(gridPage);
      }
    }

    // close filter
    if (target.classList.contains("close_filter")) {
      e.preventDefault();
      closeFilter();
    }

    // filter button
    if (target.id === "filter") {
      let artistFilterEl = document.getElementById("filter");

      let artistFilterNav = artistFilterEl.querySelector("ul");
      if (artistFilterEl.classList.contains("open")) {
        artistFilterEl.classList.remove("open");
        body.classList.remove("filter_open");
      } else {
        artistFilterEl.classList.add("open");
        body.classList.add("filter_open");
      }
    } else {
      // clicking anywhere outside of filter closes filter
      closeFilter();
    }
  });

  // artist list mouse move controls image mask

  function artistHoverInit() {
    let artistList = document.querySelector(".artists_list");
    if (typeof artistList != "undefined" && artistList != null) {
      // static element in bottom left of screen
      let artistTitleEl = document.querySelector(".artistlistpage .title");

      function showTitle(e) {
        let wrapper = e.target.closest("li");
        let title = wrapper.getAttribute("data-title");
        if (!title) {
          artistTitleEl.classList.remove("on");
          return;
        }
        artistTitleEl.querySelector("span").innerHTML = title;
        artistTitleEl.classList.add("on");
      }

      function hideImg(e) {
        let wrapper = e.target.closest("li");
        wrapper.classList.remove("active");
        artistTitleEl.classList.remove("on");
      }

      function moveImg(e) {
        // set all the needed variables
        let wrapper = e.target.closest("li");
        let img = wrapper.querySelector("img");
        let mask = wrapper.querySelector("span.white");
        let imgW = img.clientWidth;
        let imgH = img.clientHeight;
        let imgAdj = (imgW - (innerWidth - wrapper.clientWidth)) / 2;
        let leftPos = e.offsetX - imgW / 2;
        let topPos = e.offsetY - imgH / 2;
        let maskTop = 0;
        let maskRight = leftPos + imgW;
        let maskBottom = imgH;
        let maskLeft = maskRight - imgW;

        // add active class to li item
        wrapper.classList.add("active");

        // animate the mask and image based on mouse movement
        mask.style.clip =
          "rect(" +
          maskTop +
          "px " +
          maskRight +
          "px " +
          maskBottom +
          "px " +
          maskLeft +
          "px)";
        gsap.to(img, {
          left: leftPos,
          top: topPos,
          duration: 0,
        });
      }

      let artistItems = artistList.querySelectorAll("li");
      artistItems.forEach((artistItem) => {
        artistItem.addEventListener("mouseenter", showTitle);
        artistItem.addEventListener("mousemove", moveImg);
        artistItem.addEventListener("mouseleave", hideImg);
      });
    }
  }

  artistHoverInit();

  // horizontal scroll sections

  function hScrollInit() {
    const scrollContainer = document.querySelector(".horz_scroll");

    if (typeof scrollContainer != "undefined" && scrollContainer != null) {
      /*
      // intersection observer to track which image is in center of viewport
      let currentCountEl = scrollContainer.querySelector(".imgcount .current");

      function observeCallback(entries, observer) {
        for (entry of entries) {
          if (entry.isIntersecting) {
            let cellCount = entry.target.getAttribute("data-count");
            currentCountEl.innerHTML = cellCount;
          }
        }
      }

      let options = {
        root: scrollContainer, // relative to document viewport
        rootMargin: "0% 0% 0% -80%", // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0.1, // visible amount of item shown in relation to root
      };
      let observer = new IntersectionObserver(observeCallback, options);

      let cells = scrollContainer.querySelectorAll(".cell");
      cells.forEach((cell) => observer.observe(cell));
      */

      // mouse wheel event listener for scrolling
      scrollContainer.addEventListener("wheel", (evt) => {
        scrollContainer.scrollLeft += evt.deltaY;
      });
    }
  }

  hScrollInit();

  // scroll to top of page on arrow click
  if (typeof scrollTopEl != "undefined" && scrollTopEl != null) {
    scrollTopEl.addEventListener("click", function () {
      zenscroll.toY(0);
    });
  }

  // on post detail page load we need to update close link with hash value - this is to return to correct place on grid
  if (
    body.classList.contains("postpage") ||
    body.classList.contains("videoplayer")
  ) {
    let fullHash = window.location.hash;
    let cleanHash = fullHash.replace("#", "");

    let postCloseLink = document.querySelector(".closeLink");
    let currentCloseLink = postCloseLink.getAttribute("data-link");
    let newCloseLink = currentCloseLink + "#" + cleanHash;
    postCloseLink.setAttribute("href", newCloseLink);
  }

  // check for hash value on page load and scroll to grid el
  if (
    window.location.hash &&
    !body.classList.contains("slideshowpage") &&
    !body.classList.contains("postpage")
  ) {
    let fullHash = window.location.hash;
    let cleanHash = fullHash.replace("#", "");
    let targetId = "cell" + cleanHash;
    let offsetTop = document.getElementById(targetId).offsetTop;

    scroll({
      top: offsetTop,
      behavior: "smooth",
    });
  }

  function showPhotoImg(id) {
    let bgImgs = document.querySelectorAll(".background img");
    let bgImgsLength = bgImgs.length;

    let bioCells = document.querySelectorAll(".photographer_cats li");
    let bioCellsLength = bioCells.length;

    for (let i = 0; i < bgImgsLength; ++i) {
      bgImgs[i].classList.remove("active");
    }
    let activeImg = document.querySelector(
      ".background img[data-id='" + id + "']"
    );

    // get height of activeImg to align mini bio
    let activeImgRect = activeImg.getBoundingClientRect();
    let bottomAdj = bh - activeImgRect.bottom;
    activeImg.classList.add("active");

    for (let i = 0; i < bioCellsLength; ++i) {
      bioCells[i].classList.remove("active");
    }
    let activeBio = document.querySelector(
      ".photographer_cats li[data-id='" + id + "']"
    );

    activeBio.style.bottom = bottomAdj + 30 + "px";
    // adjust top offset of activeBio based on photographer name offset
    /*
    let photographerName = document.querySelector(
      ".photographer_list li[data-id='" + id + "']"
    );

    let topAdj = photographerName.offsetTop + 25;

    activeBio.style.top = topAdj + "px";
    */
    activeBio.classList.add("active");
  }

  function hidePhotoImg() {
    let bgImgs = document.querySelectorAll(".background img");
    let bgImgsLength = bgImgs.length;

    let bioCells = document.querySelectorAll(".photographer_cats li");
    let bioCellsLength = bioCells.length;

    for (let i = 0; i < bgImgsLength; ++i) {
      bgImgs[i].classList.remove("active");
    }

    for (let i = 0; i < bioCellsLength; ++i) {
      bioCells[i].classList.remove("active");
    }
  }

  // PHOTOGRAPHER LIST HOVER EVENT

  let photographer_list;

  function photoHoverInit() {
    if (body.classList.contains("overlay")) {
      photographer_list = document.querySelector(
        ".overlay_wrap .photographer_list"
      );
    } else {
      photographer_list = document.querySelector(
        ".inner.categories .photographer_list"
      );
    }
    if (typeof photographer_list != "undefined" && photographer_list != null) {
      let photographer_links = photographer_list.querySelectorAll("li a");
      let photographer_links_length = photographer_links.length;

      if (bw > 1023) {
        // triggered on hover
        for (let i = 0; i < photographer_links_length; ++i) {
          photographer_links[i].addEventListener("mouseenter", function () {
            let photoId = this.parentNode.getAttribute("data-id");
            showPhotoImg(photoId);
          });
        }
        /*
        document
          .querySelector(".photographers.inner")
          .addEventListener("mouseleave", hidePhotoImg);
        */
        //photographer_list.addEventListener("mouseleave", hidePhotoImg);
      } else {
        // timer loop to show the images
        let x = 0;
        let imgArray = [];
        for (let i = 0; i < photographer_links_length; ++i) {
          let photoId =
            photographer_links[i].parentNode.getAttribute("data-id");
          imgArray.push(photoId);
        }

        function imgReveal() {
          // show the proper image
          showPhotoImg(imgArray[x]);
          // highlight link that matched image
          let activeLink = document.querySelector(
            ".inner.categorywrap .photographer_list li[data-id='" +
              imgArray[x] +
              "'] a"
          );
          activeLink.classList.add("pageOn");
          setTimeout(function () {
            // remove page on from all links
            for (let i = 0; i < photographer_links_length; ++i) {
              photographer_links[i].classList.remove("pageOn");
            }
            hidePhotoImg();
          }, 2000);
          ++x;
          if (x == photographer_links_length) {
            x = 0;
          }
          setTimeout(imgReveal, 2500);
        }
        setTimeout(function () {
          imgReveal();
        }, 500);
      }
    }
  }

  photoHoverInit();

  // LIGHTBOX FUNCTIONS

  function lightBoxTrigger(e) {
    e.preventDefault();
    e.stopPropagation();
    let el = this;
    let cell = el.parentNode.parentNode;
    let grid = cell.parentNode;
    let id = el.getAttribute("data-id");
    if (el.classList.contains("added")) {
      getAjax("/classes/removeFromLightbox.php?picID=" + id, function (data) {
        el.classList.remove("added");
        let lbQtyCount = parseInt(lbQty.innerHTML);
        let newlbQty = lbQtyCount - 1;
        lbQty.innerHTML = newlbQty;
        if (body.classList.contains("lightboxpage")) {
          cell.parentNode.removeChild(cell);
          masonInit();
        }
      });
    } else {
      getAjax("/classes/addToLightbox.php?picID=" + id, function (data) {
        el.classList.add("added");
        let lbQtyCount = parseInt(lbQty.innerHTML);
        let newlbQty = lbQtyCount + 1;
        lbQty.innerHTML = newlbQty;
      });
    }
  }

  let lbTrigger = document.querySelectorAll(".lightbox_trigger");
  let lbTriggerLength = lbTrigger.length;
  for (let i = 0; i < lbTriggerLength; ++i) {
    lbTrigger[i].addEventListener("click", lightBoxTrigger);
  }

  // REMOVE ALL FROM LIGHTBOX

  function lbRemoveAll(e) {
    e.preventDefault();
    getAjax("/classes/removeAllLightbox.php", function (data) {
      lbQty.innerHTML = 0;
      document.querySelector(".categories .notempty").classList.add("hidden");
      document.querySelector(".categories .empty").classList.remove("hidden");
    });
  }

  let lbRemoveAllTrigger = document.querySelector(".lbClearAll");
  if (typeof lbRemoveAllTrigger != "undefined" && lbRemoveAllTrigger != null) {
    lbRemoveAllTrigger.addEventListener("click", lbRemoveAll);
  }

  // COPY LIGHTBOX LINK

  function lbCopyLink(e) {
    e.preventDefault();
    getAjax("/createLink.php", function (data) {
      let overlayEl = overlay.querySelector(".lightboxlink");
      overlayEl.innerHTML = data;
      openOverlay("lightboxlink");

      // copy URL to clipboard
      var copyText = document.getElementById("lbLink");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");
    });
  }

  let lbCopyLinkTrigger = document.querySelector(".lbCopyLink");
  if (typeof lbCopyLinkTrigger != "undefined" && lbCopyLinkTrigger != null) {
    lbCopyLinkTrigger.addEventListener("click", lbCopyLink);
  }

  // CATEGORY LINK CLICK
  let categoryLinks = document.querySelectorAll(".categories ul.catlist li a");
  let categoryLinksLength = categoryLinks.length;
  for (let i = 0; i < categoryLinksLength; ++i) {
    categoryLinks[i].addEventListener("click", getCategory);
  }

  // GSAP - Rotate header stamp on scroll
  var rotate = gsap
    .timeline({
      scrollTrigger: {
        trigger: "main",
        scrub: 1,
        start: "top top",
        end: "bottom top",
        markers: false,
      },
    })
    .to(headerStamp, {
      rotation: 360 * 5,
      duration: 1,
      ease: "none",
    });

  // artist portfolio links in nav - hover to reveal
  function hidePortfolios() {
    for (let i = 0; i < portfoliosLength; ++i) {
      portfolios[i].classList.remove("on");
    }
  }

  function showPortfolio(e) {
    e.preventDefault();

    // open the selected
    let id = this.getAttribute("data-id");
    let nav = this.closest("nav");
    let portfolio = nav.querySelector("ul.portfolio[data-id='" + id + "']");

    // close any open portfolios
    if (!portfolio.classList.contains("on")) {
      hidePortfolios();
    }

    portfolio.classList.toggle("on");
  }

  const portfolios = document.querySelectorAll("nav ul.portfolio");
  const portfoliosLength = portfolios.length;
  const portfolioLinks = document.querySelectorAll("nav .hasPortfolio");
  const portfolioLinksLength = portfolioLinks.length;
  const regularLinks = document.querySelectorAll("#bottom_bar .nosub");
  const regularLinksLength = regularLinks.length;

  for (let i = 0; i < portfolioLinksLength; ++i) {
    if (bw > 1023) {
      portfolioLinks[i].addEventListener("mouseenter", showPortfolio);
    } else {
      portfolioLinks[i].addEventListener("click", showPortfolio);
    }
  }

  for (let i = 0; i < regularLinksLength; ++i) {
    if (bw > 1023) {
      regularLinks[i].addEventListener("mouseenter", hidePortfolios);
    } else {
      regularLinks[i].addEventListener("click", hidePortfolios);
    }
  }

  for (let i = 0; i < portfoliosLength; ++i) {
    if (bw > 1023) {
      portfolios[i].addEventListener("mouseleave", hidePortfolios);
    } else {
      portfolios[i].addEventListener("click", hidePortfolios);
    }
  }

  //hamburger menu toggle

  let menuColors = ["#3C3932", "#AE4341", "#F0622C", "#5A6FA5", "#0AAD46"];

  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault();

        if (body.classList.contains("menuOn")) {
          menuBtn.querySelector(".label").innerHTML = "MENU";
          body.classList.remove("menuOn");
        } else {
          menuBtn.querySelector(".label").innerHTML = "CLOSE";
          // get random color from menuColors array
          let randomColor =
            menuColors[Math.floor(Math.random() * menuColors.length)];
          document.querySelector("header nav").style.backgroundColor =
            randomColor;
          body.classList.add("menuOn");
        }
      },
      true
    );
  }

  /*
  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );
  */

  // SCROLL ==================================

  let st = 0;
  let lastScrollTop = 0;
  let pager = document.querySelector(".pager");

  window.addEventListener(
    "scroll",
    function () {
      st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > 0) {
        overlay.classList.add("hasScrolled");
      } else {
        overlay.classList.remove("hasScrolled");
      }

      // show scroll to top element after scroll
      if (body.classList.contains("scroll_top")) {
        if (st > 150) {
          scrollTopEl.classList.add("show");
        } else {
          scrollTopEl.classList.remove("show");
        }
      }

      //iOS reveal of pager on scroll up
      if (typeof pager != "undefined" && pager != null) {
        if (st > lastScrollTop && st > 30) {
          pager.classList.add("hide");
        } else {
          pager.classList.remove("hide");
        }
      }

      lastScrollTop = st;
    },
    false
  );

  function removePortfolioLinkActive() {
    let portfolioAjaxLinks = document.querySelectorAll(".filters ul li a");
    portfolioAjaxLinks.forEach((portfolioAjaxLink) => {
      portfolioAjaxLink.classList.remove("pageOn");
    });
  }

  // PUSH STATE LOADING - PAGE TRANSITIONS
  let portfolioAjaxLinks = document.querySelectorAll("a.portfolio_link");
  portfolioAjaxLinks.forEach((portfolioAjaxLink) => {
    portfolioAjaxLink.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      let page = portfolioAjaxLink.getAttribute("href");

      // if the page variable contains /thumbs/ then we loadGrid
      if (page.indexOf("/thumbs/") >= 0) {
        loadGrid(page);
      } else {
        loadContent(page);
      }
    });
  });

  let pageAjaxLinks = document.querySelectorAll("a.ajax");
  pageAjaxLinks.forEach((pageAjaxLink) => {
    pageAjaxLink.addEventListener("click", function (e) {
      e.preventDefault();
      let page = pageAjaxLink.getAttribute("href");
      loadContent(page);
    });
  });

  window.addEventListener("popstate", function () {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    loadContent(location.pathname);
  });

  function loadGrid(page) {
    // update active state in filters
    console.log("here grid");
    let filterEl = document.querySelector(".filter");
    let isFilter = false;
    if (typeof filterEl != "undefined" && filterEl != null) {
      filterEl.classList.remove("open");
      // update the data-slug to new URL
      let imgSizeWrap = document.querySelector(".switch");
      let switchPage = page.replace("/thumbs", "");
      imgSizeWrap.setAttribute("data-slug", switchPage);
      removePortfolioLinkActive();

      let targetFilter = filterEl.querySelector("a[href='" + page + "']");
      if (typeof targetFilter != "undefined" && targetFilter != null) {
        targetFilter.classList.add("pageOn");
        setTimeout(function () {
          filterEl.classList.remove("open");
          // neeed to update the filter label with the selected filter
          filterEl.querySelector(".label .selected").innerHTML =
            ", " + targetFilter.innerHTML.toUpperCase();
        }, 500);
      }
    }

    let bodyClass, articleClass;

    contentEl = document.querySelector(".grid_wrap");
    contentEl.classList.add("transition_out");
    // make ajax call with slug as the unique identifier
    getAjax("/content.php?page=" + page + "&fromLink=yes", function (data) {
      contentEl.innerHTML = data;

      // update body class with new content
      body.classList.remove("no_footer", "creambg", "thumbspage");
      bodyClass = contentEl
        .querySelector(".grid_content")
        .getAttribute("data-body-class");
      articleClass = contentEl
        .querySelector(".grid_content")
        .getAttribute("data-article-class");

      if (bodyClass) {
        bodyClassArray = bodyClass.split(" ");
        bodyClassArray.forEach((bodyClassItem) => {
          body.classList.add(bodyClassItem);
        });
        document
          .querySelector("article.inner")
          .classList.remove(
            "with_margins",
            "artist_detail",
            "tag_page",
            "artist"
          );
        if (articleClass) {
          articleClassArray = articleClass.split(" ");
          articleClassArray.forEach((articleClassItem) => {
            document
              .querySelector("article.inner")
              .classList.add(articleClassItem);
          });
        }
      }

      // reset to top of browser
      window.scroll(0, 0);

      // call necessary loading functions
      hScrollInit();
      artistHoverInit();
      lazyLoadInit();
      masonInit();

      // init any new ajax links
      let newAjaxLinks = contentEl.querySelectorAll("a.ajax");
      newAjaxLinks.forEach((newAjaxLink) => {
        newAjaxLink.addEventListener("click", function (e) {
          e.preventDefault();
          let page = newAjaxLink.getAttribute("href");
          loadContent(page);
        });
      });

      let newPortfolioAjaxLinks =
        contentEl.querySelectorAll("a.portfolio_link");
      newPortfolioAjaxLinks.forEach((newPortfolioAjaxLink) => {
        newPortfolioAjaxLink.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          let page = newPortfolioAjaxLink.getAttribute("href");
          newPortfolioAjaxLink.classList.add("pageOn");
          loadContent(page);
        });
      });

      // update the URL with pushstate - TODO - will need to remove /grid/ from all pages
      let pageSlug = page;
      if (pageSlug === "/grid/home") {
        pageSlug = "/";
      }
      history.pushState("", "", pageSlug);

      setTimeout(function () {
        footerInit();
        contentEl.classList.remove("transition_out");
      }, 500);
    });
  }

  function loadContent(page) {
    // update active state in filters
    let filterEl = document.querySelector(".filter");
    let isFilter = false;
    if (typeof filterEl != "undefined" && filterEl != null) {
      isFilter = true;
      removePortfolioLinkActive();
      let targetFilter = filterEl.querySelector("a[href='" + page + "']");
      if (typeof targetFilter != "undefined" && targetFilter != null) {
        targetFilter.classList.add("pageOn");
        setTimeout(function () {
          filterEl.classList.remove("open");
          // neeed to update the filter label with the selected filter
          filterEl.querySelector(".label .selected").innerHTML =
            ", " + targetFilter.innerHTML.toUpperCase();
        }, 500);
      }
      // reset size toggle back to default and update data-slug to new section
      let imgSizeWrap = document.querySelector(".switch");
      if (page === "/") {
        imgSizeWrap.classList.remove("thumbs");
        // unselect img_size checkbox
        let imgSizeCheckbox = document.getElementById("img_size");
        imgSizeCheckbox.checked = false;
      }
      // update the data-slug to new URL
      let switchPage = page.replace("/thumbs", "");
      imgSizeWrap.setAttribute("data-slug", switchPage);
    }

    // based on incoming page we need to determine page transition or grid transition
    let isGrid = false;
    let isScroll = false;
    let bodyClass;
    let articleClass;
    let articleClassArray;
    let transitionTime = 1000;
    let artistListEl = document.querySelector(".artists_list");
    let horzScrollEl = document.querySelector(".horz_scroll");
    let fromList = "";
    let fromFilter = "";
    if (
      (typeof artistListEl != "undefined" && artistListEl != null) ||
      body.classList.contains("homepage")
    ) {
      fromList = "yes";
    }
    if (
      typeof horzScrollEl != "undefined" &&
      horzScrollEl != null &&
      page.indexOf("/artists/") >= 0
    ) {
      isScroll = true;
      transitionTime = 1000;
      fromList = "yes";
    } else if (
      page.indexOf("/artists/") >= 0 &&
      (typeof artistListEl == "undefined" || artistListEl == null) &&
      !body.classList.contains("homepage")
    ) {
      isGrid = true;
      transitionTime = 500;
    }

    if (
      isFilter &&
      page.indexOf("/artists") != 0 &&
      page.indexOf("/info") != 0 &&
      page != "/"
    ) {
      isGrid = true;
      fromList = "no";
      fromFilter = "yes";
    }

    // Grid transition is fade in/out / Page transition is color wash
    if (isGrid) {
      contentEl = document.querySelector(".grid_wrap");
      contentEl.classList.add("transition_out");
    } else if (isScroll) {
      // stagger fade out cells
      let scrollCells = document.querySelectorAll(".horz_scroll .cell");
      gsap.to(scrollCells, { opacity: 0, stagger: 0.15 });
      // fade out title and filter
      gsap.to(document.querySelector(".tag_title"), { opacity: 0, delay: 0.5 });
      contentEl = main.querySelector("#content");
    } else {
      contentEl = main.querySelector("#content");
      colorWash.classList.add("transition_in");
    }

    // make ajax call with slug as the unique identifier
    getAjax(
      "/content.php?page=" +
        page +
        "&fromList=" +
        fromList +
        "&fromFilter=" +
        fromFilter,
      function (data) {
        // inject new data into the target element - make sure to delay injection at least as long as transition out animation
        setTimeout(function () {
          contentEl.innerHTML = data;

          // transition in new content
          if (isGrid || isScroll) {
            contentEl.classList.add("transition_in");
            bodyClass = contentEl
              .querySelector(".grid_content")
              .getAttribute("data-body-class");
            articleClass = contentEl
              .querySelector(".grid_content")
              .getAttribute("data-article-class");
            body.classList.remove(
              "homepage",
              "no_footer",
              "hidelogo",
              "nav_background",
              "hidenav",
              "artistlistpage",
              "filter_open",
              "projectpage",
              "project_open",
              "menuOn"
            );
            if (bodyClass) {
              bodyClassArray = bodyClass.split(" ");
              bodyClassArray.forEach((bodyClassItem) => {
                body.classList.add(bodyClassItem);
              });
            }
            document
              .querySelector("article.inner")
              .classList.remove(
                "with_margins",
                "artist_detail",
                "tag_page",
                "artist"
              );
            if (articleClass) {
              articleClassArray = articleClass.split(" ");
              articleClassArray.forEach((articleClassItem) => {
                document
                  .querySelector("article.inner")
                  .classList.add(articleClassItem);
              });
            }
          } else {
            colorWash.classList.add("transition_out");
            bodyClass = contentEl
              .querySelector("article")
              .getAttribute("data-body-class");
            body.classList.remove(
              "homepage",
              "no_footer",
              "hidelogo",
              "nav_background",
              "hidenav",
              "artistlistpage",
              "filter_open",
              "projectpage",
              "project_open",
              "menuOn"
            );
            if (bodyClass) {
              bodyClassArray = bodyClass.split(" ");
              bodyClassArray.forEach((bodyClassItem) => {
                body.classList.add(bodyClassItem);
              });
            }
          }

          // reset menu label
          document.querySelector("header .menuBtn .label").innerHTML = "MENU";

          // reset to top of browser
          window.scroll(0, 0);

          // call necessary loading functions
          hScrollInit();
          artistHoverInit();
          lazyLoadInit();
          masonInit();
          footerInit();
          infoPageStampInit();

          // info page mobile check to place video under headline
          let infoPageEl = document.querySelector(".info_page");
          if (typeof infoPageEl != "undefined" && infoPageEl != null) {
            if (innerWidth <= 896) {
              let secondaryCol = infoPageEl.querySelector(
                ".secondary .column.first"
              );
              let infoHeadlineEl = infoPageEl.querySelector(
                ".primary h1.large_title"
              );
              infoHeadlineEl.after(secondaryCol);
            }
          }

          // init any new ajax links
          let newAjaxLinks = contentEl.querySelectorAll("a.ajax");
          newAjaxLinks.forEach((newAjaxLink) => {
            newAjaxLink.addEventListener("click", function (e) {
              e.preventDefault();
              let page = newAjaxLink.getAttribute("href");
              loadContent(page);
            });
          });

          let newPortfolioAjaxLinks =
            contentEl.querySelectorAll("a.portfolio_link");
          newPortfolioAjaxLinks.forEach((newPortfolioAjaxLink) => {
            newPortfolioAjaxLink.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
              let page = newPortfolioAjaxLink.getAttribute("href");
              newPortfolioAjaxLink.classList.add("pageOn");
              loadContent(page);
            });
          });
        }, transitionTime);

        // update the URL with pushstate
        history.pushState("", "", page);

        // clean up classes after transition is done, set random footer theme
        setTimeout(function () {
          if (isGrid) {
            contentEl.classList.remove("transition_out");
            contentEl.classList.remove("transition_in");
          } else {
            colorWash.classList.remove("transition_out");
            colorWash.classList.remove("transition_in");
          }

          // pick random color theme - assign to footer and color wash
          footer.className = "";
          colorWash.className = "";
          let colorTheme =
            colorThemes[Math.floor(Math.random() * colorThemes.length)];
          footerLogo.setAttribute("src", "/images/logos/" + colorTheme.logo);
          footer.classList.add(colorTheme.class);
          colorWash.classList.add(colorTheme.class);
        }, transitionTime + 1200);
      }
    );
  }
});
